import { createContext, type ReactNode, useContext } from "react";
import type { DataTableStateProps } from "./data-table-body";

const DataTableStateContext = createContext<DataTableStateProps>({});

/** 只传递请求状态，业务表格始终挂载并保留自己的列定义。 */
export function DataTableStateProvider({ children, value }: { children: ReactNode; value: DataTableStateProps }) {
  return <DataTableStateContext value={value}>{children}</DataTableStateContext>;
}

export function useDataTableState(overrides: DataTableStateProps = {}): DataTableStateProps {
  const inherited = useContext(DataTableStateContext);
  const defined = Object.fromEntries(Object.entries(overrides).filter(([, value]) => value !== undefined));
  return { ...inherited, ...defined };
}
